import { render, staticRenderFns } from "./AdditionalValue.vue?vue&type=template&id=e0e74428&scoped=true&"
import script from "./AdditionalValue.vue?vue&type=script&lang=js&"
export * from "./AdditionalValue.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalValue.vue?vue&type=style&index=0&id=e0e74428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e74428",
  null
  
)

export default component.exports